import { MutableRefObject, useCallback } from "react";

export const useTabNavigation = (tabRefs: MutableRefObject<(HTMLButtonElement | null)[]>, scrollIntoView = true) => {
    const firstTab = tabRefs.current[0];
    const lastTab = tabRefs.current[tabRefs.current.length - 1];
    const moveFocusToTab = useCallback(
        (tab: HTMLButtonElement | null) => {
            if (tab) {
                tab.focus();

                if (scrollIntoView) tab.scrollIntoView({ block: "nearest", inline: "center" });
            }
        },
        [scrollIntoView],
    );
    const moveFocusToNextTab = useCallback(
        (currentTab: HTMLButtonElement | null) => {
            const currentIndex = tabRefs.current.indexOf(currentTab);
            if (currentIndex < tabRefs.current.length - 1) {
                moveFocusToTab(tabRefs.current[currentIndex + 1]);
            }
        },
        [moveFocusToTab, tabRefs],
    );
    const moveFocusToPreviousTab = useCallback(
        (currentTab: HTMLButtonElement | null) => {
            const currentIndex = tabRefs.current.indexOf(currentTab);
            if (currentIndex > 0) {
                moveFocusToTab(tabRefs.current[currentIndex - 1]);
            }
        },
        [moveFocusToTab, tabRefs],
    );

    const onKeyDown = useCallback(
        (event: KeyboardEvent) => {
            const currentTab = tabRefs.current.find((tab) => tab === document.activeElement);
            switch (event.key) {
                case "ArrowLeft":
                    if (currentTab) moveFocusToPreviousTab(currentTab);
                    break;

                case "ArrowRight":
                    if (currentTab) moveFocusToNextTab(currentTab);
                    break;

                case "Home":
                    moveFocusToTab(firstTab);
                    break;

                case "End":
                    moveFocusToTab(lastTab);
                    break;

                default:
                    break;
            }
        },
        [firstTab, lastTab, moveFocusToNextTab, moveFocusToPreviousTab, moveFocusToTab, tabRefs],
    );

    return onKeyDown;
};
